import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HttpClientModule,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MercantilPreset } from './app.preset';
import { AdminModule } from './shared/layouts/admin/admin.module';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { TokenService } from './core/services/token.service';
import { CouponModule } from './domain/coupon/coupon.module';
import { ptBr } from './core/config/primeng-translate';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { cleanHttpParamsInterceptor } from './core/interceptors/clean-http-params.interceptor';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AdminModule,
    CouponModule,
    HttpClientModule,
    ToastModule,
  ],
  providers: [
    provideHttpClient(
      withInterceptors([cleanHttpParamsInterceptor, authInterceptor]),
    ),
    provideAnimationsAsync(),
    TokenService,
    MessageService,
    providePrimeNG({
      translation: ptBr,
      ripple: true,
      theme: {
        preset: MercantilPreset,
        options: {
          darkModeSelector: 'light',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
